import { trackEvent } from "@utils/api/tracker";
import { getUserTypeWithSessionStorage } from "src/hooks/telehealth/usePatientType";

export const onStartTelehealthFeedbackSurvey = async () => {
  const patientType = await getUserTypeWithSessionStorage();
  trackEvent("StartedTelehealthFeedback", { patientType });
};
